import { RootState } from 'modules/store';

const root = (state: RootState) => state.user;

export const getCurrentUser = (state: RootState) => root(state).currentUser;
